/* ============================================================
   SERENÉ FLORECE — Feria de las Flores 2026
   Petals · Countdown · Add-to-cart (patrón tema) · Sticky ·
   Accordions · Reveal · Analytics. Sin dependencias externas.
   ============================================================ */
(function () {
  'use strict';

  if (window.__sfFloreceInit) return;
  var root = document;
  if (!document.querySelector('.sf-florece')) return;
  window.__sfFloreceInit = true;

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lowPerf =
    (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) ||
    (navigator.deviceMemory && navigator.deviceMemory <= 4);

  /* ---------- Analytics helper (no rompe si no hay dataLayer) ---------- */
  function track(event, detail) {
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: 'sf_' + event }, detail || {}));
      }
      document.dispatchEvent(
        new CustomEvent('sf:' + event, { detail: detail || {} })
      );
    } catch (e) {}
  }
  // Delegación de clics con data-sf-event
  root.addEventListener('click', function (e) {
    var el = e.target.closest('[data-sf-event]');
    if (el) track(el.getAttribute('data-sf-event'), { label: el.getAttribute('data-sf-label') || '' });
  });

  /* ---------- Reveal on scroll ---------- */
  (function reveal() {
    var items = root.querySelectorAll('.sf-reveal');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('sf-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('sf-in');
            io.unobserve(en.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    items.forEach(function (i) { io.observe(i); });
  })();

  /* ---------- Smooth scroll interno (CTAs a #ancla) ---------- */
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#sf-"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    var target = document.getElementById(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }
  });
  var cue = root.querySelector('.sf-scroll-cue');
  if (cue) {
    cue.addEventListener('click', function () {
      var t = document.getElementById(cue.getAttribute('data-target') || 'sf-showcase');
      if (t) t.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  /* ---------- PETALS ---------- */
  (function petals() {
    var host = root.querySelector('.sf-petals');
    if (!host) return;
    var cfg = host.dataset;
    var enabled = cfg.enabled !== 'false';
    if (!enabled || reduceMotion) { host.remove(); return; }

    var once = cfg.once !== 'false';
    if (once) {
      try {
        if (sessionStorage.getItem('sf_petals_seen')) { host.remove(); return; }
        sessionStorage.setItem('sf_petals_seen', '1');
      } catch (e) {}
    }

    var intensity = (cfg.intensity || 'media').toLowerCase();
    var count = intensity === 'baja' ? 12 : intensity === 'alta' ? 24 : 18;
    if (lowPerf) count = Math.min(count, 10);

    var color1 = cfg.color1 || '#EBCBC7';
    var color2 = cfg.color2 || '#D98C8C';
    var duration = Math.max(4, Math.min(6, parseFloat(cfg.duration) || 5));

    // 3 formas de pétalo SVG livianas (inline, sin request)
    function petalSVG(c) {
      return (
        '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M13 1C7 6 4 12 4 17c0 5 4 8 9 8s9-3 9-8c0-5-3-11-9-16z" fill="' + c + '" opacity="0.9"/>' +
        '<path d="M13 3C10 8 9 13 13 24" stroke="rgba(255,255,255,0.35)" stroke-width="1"/>' +
        '</svg>'
      );
    }

    var frag = document.createDocumentFragment();
    for (var i = 0; i < count; i++) {
      var p = document.createElement('span');
      p.className = 'sf-petal';
      p.innerHTML = petalSVG(i % 2 ? color2 : color1);
      var size = 12 + Math.random() * 16; // 12-28px
      var startX = Math.random() * 100;
      var drift = (Math.random() * 40 - 20).toFixed(1);
      var dur = duration + Math.random() * 1.5;
      var delay = Math.random() * 1.2;
      var rot = (Math.random() * 720 - 360).toFixed(0);
      p.style.left = startX + 'vw';
      p.style.width = size + 'px';
      p.style.height = size + 'px';
      var el = p.querySelector('svg');
      if (el) { el.style.width = size + 'px'; el.style.height = size + 'px'; }
      p.animate(
        [
          { transform: 'translate3d(0,-10vh,0) rotate(0deg)', opacity: 0 },
          { opacity: 0.95, offset: 0.1 },
          { opacity: 0.9, offset: 0.85 },
          { transform: 'translate3d(' + drift + 'vw,110vh,0) rotate(' + rot + 'deg)', opacity: 0 }
        ],
        { duration: dur * 1000, delay: delay * 1000, easing: 'cubic-bezier(.4,.1,.5,1)', fill: 'forwards' }
      );
      frag.appendChild(p);
    }
    host.appendChild(frag);
    // limpiar tras el ciclo máximo
    setTimeout(function () { host.remove(); }, (duration + 3) * 1000);
  })();

  /* ---------- COUNTDOWN ---------- */
  (function countdown() {
    var el = root.querySelector('[data-sf-countdown]');
    if (!el) return;
    // Fecha objetivo en ISO con offset Colombia (-05:00) para no depender del reloj local del huso
    var targetAttr = el.getAttribute('data-sf-countdown'); // ISO ej 2026-08-31T23:59:59-05:00
    var target = new Date(targetAttr).getTime();
    if (isNaN(target)) return;

    var out = {
      d: el.querySelector('[data-u="d"]'),
      h: el.querySelector('[data-u="h"]'),
      m: el.querySelector('[data-u="m"]'),
      s: el.querySelector('[data-u="s"]')
    };
    var live = el.querySelector('[data-sf-count-live]');
    var timer = null;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        el.classList.add('is-ended');
        if (out.d) out.d.textContent = '00';
        if (out.h) out.h.textContent = '00';
        if (out.m) out.m.textContent = '00';
        if (out.s) out.s.textContent = '00';
        if (timer) clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      if (out.d) out.d.textContent = pad(d);
      if (out.h) out.h.textContent = pad(h);
      if (out.m) out.m.textContent = pad(m);
      if (out.s) out.s.textContent = pad(s);
      if (live && (m === 0 && s % 30 === 0)) {
        live.textContent = d + ' días, ' + h + ' horas restantes';
      }
    }
    tick();
    timer = setInterval(tick, 1000);
    // pausar cuando no visible (eficiencia)
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (en.isIntersecting) { if (!timer) { tick(); timer = setInterval(tick, 1000); } }
          else if (timer) { clearInterval(timer); timer = null; }
        });
      }, { threshold: 0 });
      io.observe(el);
    }
  })();

  /* ---------- ACCORDIONS (FAQ) ---------- */
  root.querySelectorAll('.sf-acc__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', String(!expanded));
      if (panel) {
        if (expanded) {
          panel.style.maxHeight = '0px';
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          track('faq_open', { q: btn.textContent.trim().slice(0, 60) });
        }
      }
    });
  });

  /* ---------- VIDEOS (lazy play on demand) ---------- */
  root.querySelectorAll('.sf-tst__play').forEach(function (play) {
    play.addEventListener('click', function () {
      var wrap = play.closest('.sf-tst--video');
      var vid = wrap && wrap.querySelector('video');
      if (!vid) return;
      // pausar otros
      root.querySelectorAll('.sf-tst--video video').forEach(function (v) {
        if (v !== vid) { v.pause(); }
      });
      vid.setAttribute('controls', '');
      vid.play();
      play.style.display = 'none';
      track('video_play', {});
    });
  });

  /* ---------- ADD TO CART (patrón exacto del tema: /cart/add.js + sections + drawer.open) ---------- */
  function updateCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        if (id === 'cart-icon-bubble') {
          var tb = document.getElementById('cart-icon-bubble');
          var sb = parsed.querySelector('#shopify-section-cart-icon-bubble') || parsed.querySelector('.shopify-section');
          if (tb && sb) tb.innerHTML = sb.innerHTML;
        }
        if (id === 'cart-drawer') {
          var td = document.querySelector('cart-drawer');
          var sd = parsed.querySelector('cart-drawer');
          if (td && sd) {
            td.classList.toggle('is-empty', sd.classList.contains('is-empty'));
            td.innerHTML = sd.innerHTML;
          }
        }
      } catch (e) {}
    });
  }
  function openCartDrawerSafely() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return true; }
    var bubble = document.getElementById('cart-icon-bubble');
    var link = bubble ? bubble.querySelector('a') : null;
    if (link) { link.click(); return true; }
    return false;
  }

  function bindAtc(btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) { window.location.href = btn.getAttribute('data-url') || '/cart'; return; }
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      track('add_to_cart', { variant: variantId, kit: btn.getAttribute('data-sf-label') || '' });

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: 'cart-icon-bubble,cart-drawer' })
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (er) { throw new Error(er.description || 'error'); }); return r.json(); })
        .then(function (data) {
          if (data.sections) updateCartSections(data.sections);
          btn.classList.remove('is-loading');
          btn.classList.add('is-success');
          var lbl = btn.querySelector('.sf-atc__label');
          var prev = lbl ? lbl.textContent : '';
          if (lbl) lbl.textContent = '✓ Agregado al carrito';
          if (!openCartDrawerSafely()) window.location.href = '/cart';
          setTimeout(function () {
            btn.classList.remove('is-success');
            if (lbl) lbl.textContent = prev;
          }, 1800);
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          var lbl = btn.querySelector('.sf-atc__label');
          if (lbl) lbl.textContent = 'Reintentar';
        });
    });
  }
  root.querySelectorAll('.sf-atc[data-variant-id]').forEach(bindAtc);

  /* ---------- SHOWCASE: cambio de fondo al ver cada universo ---------- */
  (function showcaseBg() {
    var showcase = document.getElementById('sf-showcase');
    if (!showcase || reduceMotion || !('IntersectionObserver' in window)) return;
    var kits = showcase.querySelectorAll('[data-sf-universe]');
    if (!kits.length) return;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting && en.intersectionRatio > 0.55) {
          var u = en.target.getAttribute('data-sf-universe');
          showcase.classList.toggle('is-fem', u === 'fem');
          showcase.classList.toggle('is-masc', u === 'masc');
        }
      });
    }, { threshold: [0.55] });
    kits.forEach(function (k) { io.observe(k); });
  })();

  /* ---------- STICKY MOBILE CTA ---------- */
  (function sticky() {
    var bar = root.querySelector('.sf-sticky');
    if (!bar) return;
    var hero = document.getElementById('sf-hero');
    var actions = root.querySelectorAll('.sf-kit__actions, .sf-final');
    var pastHero = false;
    var overActions = false;
    function render() {
      bar.classList.toggle('is-visible', pastHero && !overActions);
    }
    if ('IntersectionObserver' in window) {
      if (hero) {
        new IntersectionObserver(function (e) {
          pastHero = !e[0].isIntersecting; render();
        }, { threshold: 0, rootMargin: '-40% 0px 0px 0px' }).observe(hero);
      } else { pastHero = true; }
      var actIO = new IntersectionObserver(function (ents) {
        overActions = ents.some(function (en) { return en.isIntersecting; });
        render();
      }, { threshold: 0.1 });
      actions.forEach(function (a) { actIO.observe(a); });
    } else {
      pastHero = true; render();
    }
  })();
})();
